import { render, staticRenderFns } from "./BaseTemplate.vue?vue&type=template&id=787a7a18&"
import script from "./BaseTemplate.vue?vue&type=script&lang=js&"
export * from "./BaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BaseTemplate.vue?vue&type=style&index=0&id=787a7a18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports